import { AxiosError, HttpStatusCode } from 'axios';

import { ApiError } from '@/infra/exceptions/instances/ApiError';

export function isNotFoundError(error: unknown): boolean {
  if (error instanceof ApiError) {
    return error.status === HttpStatusCode.NotFound.toString();
  }

  if (error instanceof AxiosError) {
    return error.response?.status === HttpStatusCode.NotFound;
  }

  return false;
}
